import ExplainerSwitch from "@/features/explainers/components/ExplainerSwitch";
import type { DiaryKeyT } from "@patient-watch/types";
import { createFileRoute } from "@tanstack/react-router";

const ExplainerPage = () => {
    const { explainerType } = Route.useParams();
    return (
        <div>
            <ExplainerSwitch diaryType={explainerType as DiaryKeyT} />
        </div>
    );
};

export const Route = createFileRoute("/help/explainer/$explainerType")({
    component: ExplainerPage,
});
